import React, { useEffect, useState, useMemo } from 'react';
import { Space, Table, Tag, Button, Image, Card, Input, Flex, Select, Modal, Form, Descriptions } from 'antd';
import { useNavigate, useParams } from "react-router";
import { DeleteOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import { useForm, useWatch } from "antd/es/form/Form";
import UserService from 'services/collaborator_user';
import { useApp } from "contexts/app";
import { useAuth } from "contexts/auth";
import _ from "lodash"
import { formatCurrency } from "utils/number"
import { formatDate } from "utils/date"
import { getBankName } from "pages/website_setting/BankList";
import InputNumber from "components/input-number"
const { Search } = Input;
const service = new UserService();


const UserList = () => {
    const [customer, setCustomer] = useState({})
    const { id } = useParams();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm()

    const { showLoading, showNotify } = useApp();
    useEffect(() => {
        load();
    }, [])
    const load = async () => {
        var cus = await service.get(id);
        setCustomer(cus);
    }


    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        form.submit();
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const onFinish = async values => {
        showLoading(true);
        await service.withdraw(id, values.amount)
        await load();

        showLoading(false);
        showNotify("Đã cập nhật hoa hồng cho khách hàng");
        setIsModalOpen(false);
    };
    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };

    return (
        <>



            <Space direction='vertical'>


                <Card title="Hoa hồng" size='small'>
                    <Descriptions column={1} >


                        <Descriptions.Item label="Số dư hoa hồng">{formatCurrency(customer.commission?.current_commission)}</Descriptions.Item>
                        <Descriptions.Item label="Hoa hồng đang xử lý">{formatCurrency(customer.commission?.pending_commission)}</Descriptions.Item>

                    </Descriptions>
                    <Flex justify='flex-end'>
                        <Button type='primary' onClick={showModal}>Thanh toán</Button>
                    </Flex>

                </Card>

                <Card title="Tài khoản" size='small'>
                    <Descriptions column={1} >
                        <Descriptions.Item label="Họ và tên">{customer.full_name}</Descriptions.Item>

                        <Descriptions.Item label="Số điện thoại">{customer.phone}</Descriptions.Item>
                        <Descriptions.Item label="Ngân hàng">{getBankName(customer.bank?.bank_bin)}</Descriptions.Item>

                        <Descriptions.Item label="Số tài khoản">{customer.bank?.account_number}</Descriptions.Item>

                        <Descriptions.Item label="Tên tài khoản" >{customer.bank?.account_name}</Descriptions.Item>

                    </Descriptions>

                </Card>




            </Space>

            <Modal
                title="Thanh toán"
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
            >

                <Form
                    name="basic"
                    layout='vertical'
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                    style={{ maxWidth: 600 }}
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                    form={form}
                >
                    <Form.Item
                        label="Số tiền"
                        name="amount"
                        rules={[{ required: true, message: 'Nhập số tiền thanh toán' }]}
                    >
                        <InputNumber />
                    </Form.Item>





                </Form>
            </Modal>
        </>

    )
}


export default UserList;